<template>
  <!-- the people who tracked the task; a click opens the "Spent time" popup under them -->
  <Dropdown
    stickLeft closeOnClick overflow
    @click.stop
  >
    <template v-slot:wrapper>
      <!-- pl-1, not ml-1: the gap is part of the trigger, so the popup starts at the gap as before -->
      <div class="flex flex-row-reverse items-center pl-1">
        <UserAvatar
          :active="spentTimes[0].ttbuObj.trackingOnline"
          class="user-avatar size-5! [&_.content]:text-label"
          :withStar="spentTimes[0].userId === task.executorId"
          :user="getUser(spentTimes[0].userId)"
        />
        <UserAvatar
          v-for="item in spentTimes.slice(1, SHOW_TTBU)"
          :key="item.id"
          :active="item.ttbuObj.trackingOnline"
          :withStar="item.userId === task.executorId"
          class="user-avatar size-5! [&_.content]:text-unit"
          :user="getUser(item.userId)"
        />
        <div
          v-if="spentTimes.length > SHOW_TTBU"
          class="other-ttbus relative z-3 flex size-5 items-center justify-center
                 rounded-full border border-card bg-text-muted text-unit leading-none text-on-accent"
        >
          +{{ spentTimes.length - SHOW_TTBU }}
        </div>
      </div>
    </template>
    <template v-slot:items>
      <SpentTimeList :task="task" :spentTimes="spentTimes" />
    </template>
  </Dropdown>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import SpentTimeList from '@/components/elements/SpentTimeList.vue';

const SHOW_TTBU = 3; // with main person

defineProps({
  task: Object,
  // from useTaskSpentTimes, not empty: people who tracked the task, most tracked first
  spentTimes: Array,
});

const store = useStore();

const getUser = computed(() => store.getters['user/getUser']);
</script>
